import { Link } from "react-router-dom";

export default function BondingLiquidCTA() {
  return (
    <section className="py-20 bg-[#1A1A1A] text-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl lg:text-4xl font-bold mb-8 font-['Montserrat']">
          Need help choosing the right bonding liquid?
        </h2>
        <Link
          to="/contact"
          className="inline-block bg-[#F2C612] text-black px-10 py-4 rounded-lg font-semibold text-lg hover:bg-[#d4ae10] transition-colors whitespace-nowrap cursor-pointer"
        >
          Contact Us
        </Link>
      </div>
    </section>
  );
}